import { pageTypes } from '@nykaa/data-layer/constants';

export const contentTypes = {
  PriceList: 'PriceList',
  AboutUs: 'AboutUs',
  Categories: 'Categories',
};

interface ContentMap {
  [key: string]: string[];
}

const footerContentMap: ContentMap = {
  [pageTypes.CATEGORY]: [
    contentTypes.PriceList,
    contentTypes.AboutUs,
    contentTypes.Categories,
  ],
  [pageTypes.SEARCH_LISTING]: [contentTypes.AboutUs, contentTypes.PriceList],
};

export const isToRenderContent = (pageType: string, contentType: string) =>
  footerContentMap[pageType]?.includes(contentType, 0);
